import * as Sentry from '@sentry/browser';
import { useEffect, useRef } from 'react';
import { useAppSelector } from '../../../../../configuration/setup/hooks';
import { ToolbarSearch } from '../../../sharedComponents/filter/ToolbarSearch';
import { getVinSearchFilter, setVinSearchFilter } from '../../../reducers/compoundManagementSlice';
import { parseUniqueEntries } from '../../../sharedComponents/inputListParser';

const MAX_VINS_SEARCH = 1000;

export const CompoundManagementVinSearch = () => {
    const vinSearch = useAppSelector(getVinSearchFilter);
    const hasLoggedSearchOverLimit = useRef(false);

    useEffect(() => {
        const vinsLength = parseUniqueEntries(vinSearch).length;
        if (vinsLength > MAX_VINS_SEARCH && !hasLoggedSearchOverLimit.current) {
            Sentry.captureMessage(`Searched for more than ${MAX_VINS_SEARCH} VINs in compound VIN search.`);
            hasLoggedSearchOverLimit.current = true;
            return;
        }
        if (vinsLength <= MAX_VINS_SEARCH) {
            hasLoggedSearchOverLimit.current = false;
        }
    }, [vinSearch]);

    return (
        <ToolbarSearch
            getSearchTerm={getVinSearchFilter}
            setSearchTerm={setVinSearchFilter}
            tooltipMessageId="outboundOrderBook.common.table.toolbar.searchVin.tooltip"
            placeholderMessageId="outboundOrderBook.common.table.toolbar.searchVin.placeholder"
        />
    );
};
